import {
  Component, ChangeDetectorRef, OnInit, OnDestroy, ElementRef, ViewChildren, ViewChild,
  Inject, PLATFORM_ID, ChangeDetectionStrategy, NgZone, QueryList
} from '@angular/core';
import { isPlatformBrowser } from '@angular/common';
import { Router, ActivatedRoute, ParamMap } from '@angular/router';
import { NavigationService } from '../shared/navigation/navigation.service';
import { FormService } from '../forms/forms.service';
import { Form } from '../forms/form.model';
import { environment } from '../../environments/environment';
import { Popup, Settings } from '../shared/navigation/pages.model';
import { MatStep, MatStepper } from '@angular/material/stepper';
import { Subscription } from 'rxjs';
import { take } from 'rxjs/operators';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { UtilsService } from '../shared/services/utils.service';
import { utils } from '../shared/helpers/utils';
import { StepperSelectionEvent } from '@angular/cdk/stepper';
import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';
import { FileItem, FileUploader, ParsedResponseHeaders } from 'ng2-file-upload';

@Component({
  selector: 'app-forms',
  templateUrl: 'forms.component.html',
  styleUrls: ['forms.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})

export class FormsComponent implements OnInit, OnDestroy {

  public regulations = false;
  public pageAnimated = 'invisible';
  public pageName = environment.name;
  public pageTitle: string;
  public pageContent: string;
  public cdn = environment.cdn;
  public countries = utils.countries;
  public gallery: any[] = [
    { path: '/assets/career/career1.jpg', title: '', loaded: false },
    { path: '/assets/career/career2.jpg', title: '', loaded: false },
    { path: '/assets/career/career3.jpg', title: '', loaded: false },
    { path: '/assets/career/career4.jpg', title: '', loaded: false },
  ];
  public popup: Popup;
  public settings: Settings = new Settings;
  public sub: Subscription = null;
  public active = 0;

  public uploader: FileUploader = new FileUploader({});
  public uploaded: string[] = [];
  public errored: any[] = [];
  public hasBaseDropZoneOver = false;
  public photoExtensions = ['jpg', 'png'];
  public filesExtensions = ['txt', 'pdf', 'docx', 'doc', 'xls', 'xlsx', 'rtx'];
  public dir = 'generate';
  public attachments = [];
  public loading_file = false;

  // available days to calendar
  public loading = false;
  public sent = false;
  public res = 0;
  public form: FormGroup;

  public selectedForm: Form;
  public forms: Form[] = [];
  public formsSelected: Form[] = [];
  public citys: string[] = [];
  public days = [];
  public daysExclude = [];
  public daysInclude = [];
  public currentHour = 9;
  public daysReserved = [];
  public maxForms = 0;
  public hours = ['10:00', '11:00', '12:00', '13:00', '14:00', '15:00', '16:00', '17:00'];
  public hoursSaturday = ['10:00', '11:00', '12:00', '13:00'];
  public hoursSunday = ['11:00', '12:00', '13:00', '14:00'];
  public hoursExtra = ['10:00', '11:00', '12:00', '13:00', '14:00'];
  public tables = [];
  public dayhour = [];

  public started = false;
  public orientation = 'vertical';
  public isLinear = true;
  public slider_index = 0;
  public slider_visible = 6;

  @ViewChild(MatStepper) stepper: MatStepper;
  @ViewChildren(MatStep, { read: ElementRef }) steps: QueryList<ElementRef>;
  @ViewChild('video1') video1: ElementRef;
  @ViewChild('video2') video2: ElementRef;
  @ViewChild('slider', {static: false}) slider;


  constructor(@Inject(PLATFORM_ID) private platformId: Object, private router: Router, private route: ActivatedRoute, private ngZone: NgZone,
    private navigationService: NavigationService, private cdr: ChangeDetectorRef, private loader: UtilsService, 
    private fb: FormBuilder, private formsService: FormService) {
  }

  ngOnInit() {
    gsap.registerPlugin(ScrollTrigger);

    this.sub = this.navigationService.navigation.subscribe(this.pageChanged);
    this.pageTitle = this.route.snapshot.data.name;
    this.navigationService.item(this.route.snapshot.data.id).pipe(take(1)).subscribe((result: any) => {
      this.pageContent = result.content;
      this.cdr.detectChanges();
    });
    this.createForm();

    this.setOptions();
    this.uploader.onSuccessItem = (item, response, status, headers) => this.onSuccessItem(item, response, status, headers);
    this.uploader.onCompleteAll = () => this.onCompleteAll();
  }

  ngAfterViewInit() {

    this.ngZone.runOutsideAngular(() => {

      (() => {

        const tl = gsap.timeline({
          scrollTrigger: {
            trigger: ".in_numbers_wrap",
            start: "top 75%",
            // markers: true
          }
        });
        tl.fromTo(".in_numbers", {yPercent: 200}, {yPercent: 0, duration: 0.3, stagger: 0.1, ease: "power1"});

        // gsap.to(".in_numbers", {
        //   scrollTrigger: ".in_numbers_wrap", // start the animation when ".box" enters the viewport (once)
        //   y: 100,
        //   duration: 3,
        //   start: "bottom center",
        //   markers: true
        // });


      })();
    }); //zone
  }

  pageChanged = (menu: any) => {
    if (Object.keys(menu.menu).length) {
      this.settings = menu.settings;
      this.cdr.detectChanges();
    }
  }

  startProcess() {
    utils.scrollTo(70, {}, 100);
    this.started = true;
  }

  goForward() {
    if (this.started === false) this.started = true;
    this.stepper.next();
  }

  stepChange(e: StepperSelectionEvent) {
    const stepId = this.stepper._getStepLabelId(e.selectedIndex);
    const stepElement = document.getElementById(stepId); // step header ele
    utils.scrollTo(70 + e.selectedIndex*stepElement.scrollHeight, {}, 200);
    switch (e.selectedIndex) {
      case 0: {
        this.selectedForm = undefined;
        break;
      }
      case 1: {
        if((<any>window).dataLayer) {
          (<any>window).dataLayer.push({
            event: 'form_step_1',
          });
        }
        break;
      }
      // case 2: {
      //   if((<any>window).dataLayer) {
      //     (<any>window).dataLayer.push({
      //       event: 'form_step_2',
      //     });
      //   }
      //   break;
      // }
      case 2: {
        if((<any>window).dataLayer) {
          (<any>window).dataLayer.push({
            event: 'form_completed',
          });
        }
        break;
      }
    }

  }

  dateChanged(date: string) {
    this.goForward();
  }

  createForm() {
    this.form = this.fb.group({
      id_form: ['', Validators.required],
      // date: ['', Validators.required],
      name: ['', Validators.required],
      email: ['', [Validators.required, Validators.email]],
      country: ['PL'],
      phone: ['', [Validators.required, Validators.minLength(9), Validators.maxLength(9)]],
      comment: [''],
      attachments: [''],
      rodo: ['', Validators.requiredTrue]
    });

    const countryCtrl = this.form.get('country');
    const phoneCtrl = this.form.get('phone');
    // const dateCtrl = this.form.get('date');

    countryCtrl.valueChanges.subscribe((c: string) => {
      if (c === 'PL') {
        phoneCtrl.setValidators([Validators.required, Validators.minLength(9), Validators.maxLength(9)]);
      } else {
        phoneCtrl.setValidators([Validators.required]);
      }
      phoneCtrl.updateValueAndValidity();
    });

    // dateCtrl.valueChanges.subscribe((c: string) => {
    //   this.cdr.detectChanges(); 
    //   this.goForward();
    // });

    this.fetchForm(0);
  }

  fetchForm(v: number) {
    this.formsService.items({  }).pipe(take(1)).subscribe(forms => {
      if (forms.items) {
        this.forms = forms.items || [];
        if (isPlatformBrowser(this.platformId)) {
          // if (window.innerWidth > 768) {
            this.formsSelected = this.forms;
          // }
        }
      } else {
        this.forms = [];
      }
      this.cdr.detectChanges();
    }, error => {
      //error
    });
  }

  getAvailableDays(shop: any) {

    this.active != shop.id ? this.active = shop.id : this.active = 0;
    this.selectedForm = this.forms.find(x => +x.id == shop.id);
    this.form.controls.id_form.setValue(shop.id);
    this.cdr.detectChanges();
    // this.goForward();

  }

  sliderEvents(e: any) {
    this.slider_index = e.index;
    this.slider_visible = e.visible;
  }

  copyInputMessage(el: HTMLElement){
    navigator.clipboard.writeText(el.innerText);
  }

  submit() {
    if (this.form.status === 'VALID') {
      this.loading = true;
      this.sent = true;
      const formModel = this.form.value;
      if (this.attachments.length > 0) {
        formModel.attachments = this.attachments;
      }
      this.sub = this.formsService.save(formModel).subscribe((result: any) => {
        this.res = result.message;
        this.loading = false;
        if (+result.message !== 3){
          this.goForward();
        } else {
          if((<any>window).dataLayer) {
            (<any>window).dataLayer.push({
              event: 'form_error',
              value: 'Already reserved'
            });
          }
        }
        this.cdr.detectChanges();
      }, error => {
        this.res = 2;
        this.sent = false;
        this.loading = false;
        if((<any>window).dataLayer) {
          (<any>window).dataLayer.push({
            event: 'form_error',
            value: 'Form form error'
          });
        }
        this.cdr.detectChanges();
      }
      );
    } else {
      // if (!this.form.controls.rodo.valid) {
        this.form.controls.rodo.markAsDirty();
        this.cdr.detectChanges();
      // }
    }
  }

  setOptions() {
    const token = localStorage.getItem('user_token');
    const options = {
      url: environment.api + '/upload',
      // authToken: 'Bearer ' + token,
      additionalParameter: { module: 'users', dir: 'cv', limit: 5, miniatures: {} },
      queueLimit: 1
    };
    this.uploader.setOptions(options); //  = new FileUploader(options);
  }

  onSuccessItem(item: FileItem, response: string, status: number, headers: ParsedResponseHeaders): any {
    const res = JSON.parse(response);
    this.attachments.push(res.filename)
    
    if (res.message === 'error') {
      let error = '';
      switch(+res.upload_code) {
        case 1:
        case 2:
          error =  $localize `:@@upload_error_1:Maksymalny rozmiar pliku został przekroczony`;
          break;
        case 3:
          error =  $localize `:@@upload_error_2:Twój plik został wgrany częściowo - spróbuj ponownie`;
          break;
        case 4:
          error =  $localize `:@@upload_error_3:Pliku nie udało się przesłać`;
          break;
        case 6:
        case 7:
        case 8:
          error =  $localize `:@@upload_error_4:Nie udało się zapisać pliku - skontaktuj się z nami e-mailowo`;
          break;
      }
      this.errored.push({name: item.file.name, error: error});
    } else {
      this.uploaded.push(item.file.name);
    }

    this.cdr.detectChanges();
    // if (this.dir !== res.dir) {
    //   this.dir = res.dir;

    //   this.setOptions();
    // }
  }

  onCompleteAll() {
    this.loading_file = false;
    this.uploader.clearQueue();
    this.cdr.detectChanges();
  }

  fileDropped(e: any): void {
      this.loading_file = true;
      this.uploader.uploadAll();
  }

  ngOnDestroy() {
    if (this.sub) {
      this.sub.unsubscribe();
    }
  }


}
